<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6">
        <b-card>
          <div slot="header">
            <strong><i class="fa fa-align-justify"/> Changement Raison sociale CeV</strong>
          </div>
          <b-row>
            <label style="margin-left:14px">Ce module permet de modifier la raison sociale d'un établissement sur CEV</label>
            <b-col md="12" v-if="formSearch">
              <label><u>Veuillez saisir le SIRET a modifier</u></label>
              <b-form>
                <b-row class="mb-1">
                  <b-col sm="2">
                    <label for="siret"><strong>SIRET : </strong></label>
                  </b-col>
                  <b-col>
                    <b-form-input
                      id="siret"
                      type="text"
                      :class="{hasError: errors.siret !== ''}"
                      v-model="siret"
                    />
                    <span class="field-error">{{ errors.siret }}</span>
                  </b-col>
                </b-row>
                <div class="mt-4" slot="footer">
                  <b-button type="button" @click.prevent="searchSiret" size="md" class="pull-right" variant="primary">
                    <i class="fa fa-arrow-right"/> Etape suivante
                  </b-button>
                  <!-- <b-button type="button" @click.prevent="cancel" size="md" class="pull-right mr-3" variant="secondary">
                    <i class="fa fa-close"/> Annuler
                  </b-button> -->
                </div>
              </b-form>
            </b-col>
            <b-col md="12" v-if="formEdit">
              <label><u>Veuillez indiquer le nouveau libelle pour le siret {{ this.siret }}</u></label>
              <b-row class="mb-1">
                <b-col sm="3">
                  <label><strong>Ancien libellé :</strong></label>
                </b-col>
                <b-col>
                  <label>{{ etablissement.libelle }}</label>
                </b-col>
              </b-row>
              <b-form>
                <b-row class="mb-1">
                  <b-col sm="2">
                    <label for="libelle"><strong>Nouveau libellé : </strong></label>
                  </b-col>
                  <b-col>
                    <b-form-input
                      id="libelle"
                      type="text"
                      :class="{hasError: errors.libelle !== ''}"
                      v-model="libelle"
                    />
                    <span class="field-error">{{ errors.libelle }}</span>
                  </b-col>
                </b-row>
                <div class="mt-4" slot="footer">
                  <b-button type="button" @click.prevent="saveRaisonSociale" size="md" class="pull-right" variant="primary">
                    <i class="fa fa-save"/> Valider
                  </b-button>
                  <b-button type="button" @click.prevent="cancel" size="md" class="pull-right mr-3" variant="secondary">
                    <i class="fa fa-close"/> Annuler
                  </b-button>
                </div>
              </b-form>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
  import { getAccessToken, getBaseUrl, getIdToken, getProvider } from '../../utils/auth'
  import { isEmpty } from "@/utils/fileHelper"

  export default {
    data() {
      return {
        siret: '',
        formSearch: false,
        formEdit: false,
        etablissement: {},
        libelle: '',
        isEmpty,
        errors: {
          siret: '',
          libelle: ''
        }
      }
    },
    mounted() {
      this.formSearch = true
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl()
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
      this.$axios.defaults.headers.common['Accept'] = 'application/json'
      this.$axios.defaults.headers.common['Provider'] = getProvider()
    },
    methods: {
      searchSiret() {
        if (this.validateSiret()) {
          this.$store.commit('IS_LOADING', true)
          let self = this
          let dataPost = {}
          dataPost.siret = this.siret
          this.$axios
            .post("/espaceEmployeur/inscription-cev/search/raison-sociale", dataPost)
            .then(response => {
              this.$store.commit("IS_LOADING", false)
              if (!isEmpty(response.data.etablissement)) {
                this.formSearch = false
                this.formEdit = true
                this.etablissement = response.data.etablissement
                this.errors.siret = ''
              } else {
                this.errors.siret = "Ce SIRET n'existe pas"
                this.formSearch = true
                this.formEdit = false
              }
            })
            .catch(function (error) {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue lors de la recherche du SIRET, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      saveRaisonSociale() {
        if (this.validateLibelle()) {
          this.$store.commit('IS_LOADING', true)
          let dataPost = {}
          dataPost.siret = this.siret
          dataPost.libelle = this.libelle
          let self = this
          this.$axios
            .post("/espaceEmployeur/inscription-cev/edit/raison-sociale", dataPost)
            .then(response => {
              this.$store.commit("IS_LOADING", false)
              if (response.data.result == true) {
                this.$swal({
                  position: 'top',
                  type: 'success',
                  title: 'Modification avec succès',
                  text: 'Le changement de raison sociale a été fait',
                  showConfirmButton: false,
                  timer: 2500
                });
                this.formSearch = true
                this.siret = ''
                this.libelle = ''
                this.formEdit = false
              }
            })
            .catch(function (error) {
              self.$store.commit("IS_LOADING", false);
              self.$swal({
                position: "top",
                type: "error",
                title: "Attention !!",
                text: "Une erreur est survenue lors de l'enregistrement de la raison sociale, si le problème persiste merci de faire un ticket au support DOSI",
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      validateSiret() {
        this.clearErrors()
        let valid = true
        if (this.siret !== "") {
          this.siret = this.siret.replaceAll(' ', '')
          if (this.siret.length < 14|| this.siret.length > 14) {
            this.errors.siret = "Le SIRET doit contenir 14 caractères";
            valid = false;
          }
          if (/^\d+$/.test(this.siret) === false) {
            this.errors.siret = 'Le SIRET ne doit contenir que des chiffres'
            valid = false
          }
        } else {
          this.errors.siret = "Le SIRET est obligatoire"
          valid = false
        }
        return valid;
      },
      validateLibelle() {
        this.clearErrors()
        let valid = true
        if (this.libelle === "") {
          this.errors.libelle = "Le libellé est obligatoire"
          valid = false
        }
        return valid;
      },
      clearErrors() {
        this.errors.siret = ''
        this.errors.libelle = ''
      },
      cancel() {
        // this.$router.push({path: '/espace-employeur/inscription-cev'})
        this.formSearch = true
        this.formEdit = false
        this.siret = ''
      }
    }
}
</script>

<style>
</style>
